import { BROWSER_AUTOCOMPLETE } from "config/browserAutocomplete";

export const defineBrowser = () => {
  const isEdgeBrowser =
    window.navigator.userAgent.includes("Edg") ||
    window.navigator.userAgent.includes("Edge");

  return isEdgeBrowser
    ? BROWSER_AUTOCOMPLETE.newPassword
    : BROWSER_AUTOCOMPLETE.disabled;
};
